module.exports = __webpack_public_path__ + "static/media/school-profile-ad7.5ed55d6b.png";